import { schema } from 'normalizr';

const profile = new schema.Entity('profile', {}, { idAttribute: 'profileId' });

const ProfileSchema = {
	PROFILE: profile
};

export default ProfileSchema;
